import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../pics/logoblu.png';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav>
      <div className="nav-container">
        <Link to="/" className="nav-brand">
          <img src={logo} alt="Loveario Logo" className="nav-logo-img" /> <p>Loveario</p>
        </Link>
        <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
        <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <li>
            <Link to="/" className={isActive('/')} onClick={handleLinkClick}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" className={isActive('/about')} onClick={handleLinkClick}>
              About
            </Link>
          </li>
          <li>
            <Link to="/lakehouses" className={isActive('/lakehouses')} onClick={handleLinkClick}>
              Lakehouses
            </Link>
          </li>
          <li>
            <Link to="/contact" className={isActive('/contact')} onClick={handleLinkClick}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
